import { render, staticRenderFns } from "./RatingFile.vue?vue&type=template&id=627a6247"
import script from "./RatingFile.vue?vue&type=script&lang=js"
export * from "./RatingFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports